import { useTranslation } from 'react-i18next';
import Icon from './empty-state-image.svg';
import s from './index.module.scss';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className={s.empty}>
      <div className={s.empty_content}>
        <img src={Icon} alt="icon" width={128} height={128} />
        <div className="f-body-md f-500">
          {t('withdraw:withdrawals_history.empty_title')}
        </div>
        <div className="f-body-sm f-400">
          {t('withdraw:withdrawals_history.empty_desc')}
        </div>
      </div>
    </div>
  );
};
